import { RecommendationSource } from '~/api/Catalog';

export const RECOMMENDATION_TITLES: Record<RecommendationSource, string> = {
  [RecommendationSource.CARD_SIMILAR]: 'similarProducts',
  [RecommendationSource.CARD_ASSOCIATIONS]: 'matchingProducts',
  [RecommendationSource.CART]: 'matchingProducts',
};

export const CAROUSEL_MAX_ITEMS = 20;
